import { render } from "./ConfigPlantJournals.vue?vue&type=template&id=5abeb700"
import script from "./ConfigPlantJournals.vue?vue&type=script&lang=js"
export * from "./ConfigPlantJournals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__